export class Constants {
    static readonly DATE_FMT = 'MMM dd, yyyy';
    static readonly DATE_FMT_ALT = 'MMM DD, YYYY'; // momentjs displaying format
    static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;
}
